/* eslint sort-keys: "error" */

import { rem, Link } from '@vimeo/bokeh';
import { Callable } from '@vimeo/core/types/generic';
import { translate } from '@vimeo/i18n-runtime';

export const interactionTranslations = {
  ask: translate('Ask'),
  chatIsClosed: translate('Chat is closed'),
  contentYouSubmitThroughChatIsSubjectToVimeosTermsOfServiceAndPrivacyPolicy: () =>
    translate({
      replacements: {
        TERMS_LINK: (children: string) => (
          <Link
            href={'/terms'}
            target={'_blank'}
            key={'terms'}
            variant={'brand'}
            sx={{
              fontSize: rem(14),
            }}
          >
            {children}
          </Link>
        ),
        // eslint-disable-next-line sort-keys
        PRIVACY_LINK: (children: string) => (
          <Link
            href={'/privacy'}
            target={'_blank'}
            key={'policy'}
            variant={'brand'}
            sx={{
              fontSize: rem(14),
            }}
          >
            {children}
          </Link>
        ),
      },
      singular:
        'Content you submit through chat is subject to the {TERMS_LINK}Terms of Service{/TERMS_LINK} and {PRIVACY_LINK}Privacy Policy{/PRIVACY_LINK}',
    }),
  copyCode: translate('Copy code'),
  copyLink: translate('Copy link'),
  embed: translate('Embed'),
  engagementToolsEmbed: translate('Engagement tools embed'),
  enterPassword: translate('Enter password'),
  fixed: translate('Fixed'),
  fullPageChatLink: translate('Full-page chat link'),
  haveQuestion: translate('Have a question?'),
  host: translate('Host'),
  ifYouAreModeratorForThisEvent: translate(
    'If you are a moderator for this event you can log in using your Vimeo account',
  ),
  incorrectPassword: translate('Incorrect password'),
  joinAudience: translate('Join audience'),
  joinConversation: translate('Join the conversation'),
  joinRoom: translate('Join room'),
  joinTheAudienceToParticipate: translate(
    'Join the audience to participate in chat, polls, and quizzes',
  ),
  joinTheAudienceWhenTheEventIsLive: translate('Join the audience when the event is live'),
  joinVimeo: translate('Join Vimeo'),
  loginToVimeo: translate('Log in to Vimeo'),
  loginWithVimeo: translate('Log in with Vimeo'),
  me: translate('me'),
  moderatorLogIn: translate('Moderator log in'),
  noActiveQna: translate('No active Q&A'),
  noPollCurrentlyAvailable: translate('No polls are currently available'),
  noPollsArchived: translate('No polls have been archived'),
  onEmbedCopy: translate('Copied!'),
  openChatInBrowser: translate(
    'Open chat in a browser. Team members with Contributor Plus or Admin access can moderate.',
  ),
  or: translate('or'),
  passwordRequired: translate('Password required'),
  pixels: translate('Pixels'),
  registerOrSignIntoEventToJoinAudience: (
    onRegisterLinkClick: Callable,
    onSignInLinkClick: Callable,
  ) =>
    translate({
      replacements: {
        REGISTER_LINK: (children: string) => (
          <Link
            key={'registrant-register-link'}
            variant={'brand'}
            sx={{
              fontSize: rem(14),
            }}
            as={'span'}
            onClick={onRegisterLinkClick}
          >
            {children}
          </Link>
        ),
        SIGN_IN_LINK: (children: string) => (
          <Link
            key={'registrant-sign-in-link'}
            variant={'brand'}
            sx={{
              fontSize: rem(14),
            }}
            as={'span'}
            onClick={onSignInLinkClick}
          >
            {children}
          </Link>
        ),
      },
      singular:
        '{REGISTER_LINK}Register{/REGISTER_LINK} or {SIGN_IN_LINK}sign into the event{/SIGN_IN_LINK} to join the audience',
    }),
  registrationRequired: translate('Registration required'),
  responsive: translate('Responsive'),
  resultsAreIn: translate('The results are in'),
  sendMessage: translate('Send a message'),
  sendMessageToStartChat: translate('Send a message to start the conversation'),
  shareYourEmailToJoin: translate('Share your email to join'),
  shareYourNameToJoin: translate('Share your name to join'),
  showResults: translate('Show results'),
  sortBy: translate('Sort by:'),
  submit: translate('Submit'),
  turnOn: translate('Turn on'),
  turnOnChatToEngageWithYourAudience: translate('Turn on chat to engage with your audience'),
  videoPlayerEmbed: translate('Video player embed'),
  vote: translate('Vote'),
  waitingForFinalResults: translate('Waiting for final results'),
  whenAudienceEngagementIsOpen: translate("When audience engagement is open, you'll see it here."),
  youDoNotHaveAccessToModerateThisEvent: translate(
    'You do not have access to moderate this event. Please contact to your team admin.',
  ),
};
